import { render, staticRenderFns } from "./UserChat.vue?vue&type=template&id=226726c6&scoped=true&"
import script from "./UserChat.vue?vue&type=script&lang=js&"
export * from "./UserChat.vue?vue&type=script&lang=js&"
import style0 from "./UserChat.vue?vue&type=style&index=0&id=226726c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226726c6",
  null
  
)

export default component.exports